module.exports = __webpack_public_path__ + "img/thumb_wallpaper_5times_lossless.f835d018.png";